require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ember-part-2-getting-started.json") })
        }
      }, "path---blog-ember-part-2-getting-started");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ember-part-2-getting-started!./.cache/json/blog-ember-part-2-getting-started.json
// module id = 787
// module chunks = 231608221292675